import React, { useState } from 'react'
import { fetchAllAttendance, fetchOvertimeAttendance } from '../../services/ReportService'

const ReportComponent = () => {
    const [loading, setLoading] = useState(false) // Loading state
    const [dateStart, setDateStart] = useState('')
    const [dateEnd, setDateEnd] = useState('')
    const [recordType, setRecordType] = useState('regular') // State for record type

    const fetchDtrData = async (event) => {
        event.preventDefault() // Prevent default form submission

        // Validate the date range
        if (new Date(dateStart) > new Date(dateEnd)) {
            alert('The start date cannot be after the end date.')
            return
        }

        setLoading(true) // Set loading to true while fetching data

        try {
            const attendance = {
                dateStart: dateStart,
                dateEnd: dateEnd
            }
            let response = null

            if (recordType === 'regular') {
                response = await fetchAllAttendance(attendance)
            } else if (recordType === 'overtime') {
                response = await fetchOvertimeAttendance(attendance)
            }

            const url = window.URL.createObjectURL(new Blob([response]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', `employee_dtr_${recordType}_${dateStart}_${dateEnd}.xlsx`) // Set the file name
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
        } catch (error) {
            console.error('Error fetching DTR data:', error)
            alert('Failed to generate report. Please try again.')
        } finally {
            setLoading(false) // Set loading to false after the API call
        }
    }

    return (
        <div className="page-container">
            <div className="page-toolbar">
                <h1 className="page-title">Generate Daily Time Records</h1>
            </div>

            {/* Date Range Selectors - Responsive */}
            <div className="card-surface p-4 sm:p-8 w-full max-w-xl mx-auto">
                <form id="dtrForm" onSubmit={fetchDtrData} className="space-y-4">
                    <div>
                        <label className="form-label">Record Type</label>
                        <select
                            id="recordType"
                            value={recordType}
                            onChange={(e) => setRecordType(e.target.value)}
                            className="input-field mt-1"
                        >
                            <option value="regular">Regular</option>
                            <option value="overtime">Overtime</option>
                        </select>
                    </div>

                    <div>
                        <label className="form-label">Date Start</label>
                        <input
                            type="date"
                            id="dateStart"
                            value={dateStart}
                            required
                            onChange={(e) => setDateStart(e.target.value)}
                            className="input-field mt-1"
                        />
                    </div>

                    <div>
                        <label className="form-label">Date End</label>
                        <input
                            type="date"
                            id="dateEnd"
                            value={dateEnd}
                            required
                            onChange={(e) => setDateEnd(e.target.value)}
                            className="input-field mt-1"
                        />
                    </div>

                    <div className="mt-6">
                        <button type="submit" className="btn-primary w-full sm:w-auto">
                            {loading ? 'Generating...' : 'Generate'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    )
}

export default ReportComponent
